module.exports = __webpack_public_path__ + "img/m9.4b68ad9d.jpg";